import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useCollectorsClients = () => {
  return useQuery({
    queryKey: ["collectors-clients"],
    queryFn: async () => {
      const res = await axios.get("/api/v1/admin/collectors/clients");
      return res.data;
    },
    staleTime: 1000 * 60 * 2,
  });
};
